import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, SimpleChange } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-find',
  template: `
  <div class="input-group" [formGroup]="form">
    <input class="form-control find" [value]="selectedItem ? selectedItem['TEUR'] : ''" ngxTypeahead [taParams]="params" 
      (focusout)="selectionFinished()" formControlName="editor" (focus)="startSelection()"
      [taList]="list" [taItemTpl]="itemTemplate" (taSelected)="selectedStatic($event)" maxlength="25"
      placeholder="{{(isHebrewOnly ? 'עברית' : 'אנגלית')}}" id="find_input_{{id}}">
    <app-virtual-keyboard *ngIf="withVirtualKeyboard == 'true'" [control]="f.editor" [position]="vkposition" [id]="_id"
      (keyup)="keyup_event($event)" (closed)="selectionFinished()">
    </app-virtual-keyboard>
    <ng-template #itemTemplate let-item>
      <div class="search-list">
        <div class="inline-block">
          <div class="item-name">{{item.result['TEUR']}}</div>
          <div class="item-role item-block"></div>
        </div>
      </div>
    </ng-template>
    <div class="input-group-prepend cursor">
      <span class="input-group-text">
        <i class="fa fa-search" aria-hidden="true"></i>
      </span>
    </div>
    <control-messages class="after-prepend" [control]="control"></control-messages>
  </div>
  `,

  styles: [
    `.after-prepend {
      position: absolute;
      top: 36px;
    }`
  ]
})

export class FindComponent implements OnInit {
  selectedItem;
  @Input() list: any[];
  @Input() control: FormControl;
  @Input() disabled = false;
  @Input() isHebrewOnly = true;
  @Input() withVirtualKeyboard = 'true';
  @Input() id = "";
  _id = "";
  @Input() vkposition = "";
  @Output() changed = new EventEmitter<string>();
  doubleEvent = new EventEmitter<any>();

  public params: object = {
    token: 'REPORT-TOKEN',
    something: 'report',
    query: this.selectedItem
  };

  form: FormGroup = null;

  constructor() { 
    this.form = new FormGroup ({
      editor : new FormControl('')
    });

    this.doubleEvent.subscribe (d => {
        let event;
        event = d; 
        setTimeout(() => document.getElementById("find_input_" + this.id).dispatchEvent(event), 500); 
    });
  }

  ngOnInit(): void {
    this._id = this.id;
  }

  public get f() {
    return this.form.controls;
  }

  keyup_event(event) {
    let el = document.getElementById("find_input_" + this.id);
    el.dispatchEvent(event);
    this.doubleEvent.emit(event);   
  }

  startSelection() {
    if (this.selectedItem)
      this.form.controls.editor.setValue(this.selectedItem['TEUR']);
  }

  selectionFinished() {
    if (!this.selectedItem || (this.selectedItem['TEUR'] != this.form.controls.editor.value))
    {
        this.selectedItem = null;
        this.setValue("");
        this.form.controls.editor.setValue("");
    }
  }

  selectedStatic(item) {
      this.selectedItem = item;
      this.setValue(item['KOD']);
  }

  setValue(val) {
    if (this.control) {
      this.control.setValue(val);
      this.control.markAsTouched();
      this.changed.emit(val);
    }      
  }

  ngOnChanges(changes: SimpleChanges) {
      const disabled: SimpleChange = changes.disabled;
      if (disabled) 
        this.disabled = disabled.currentValue;
        
      if (this.disabled)
        this.form.controls.editor.disable();
      else
        this.form.controls.editor.enable();
  }
}
